import CardForm from '../../components/Cards/Form';

import PageWrapper from '../../components/PageWrapper';

const Page: React.FC = () => {
  return (
    <PageWrapper pageTitle="New Card">    
      <CardForm />
    </PageWrapper>
  )
}

export default Page;